import { Box, BoxProps, Table as CTable } from '@chakra-ui/react';
import { forwardRef } from 'react';

export const Table = forwardRef(({ children, sx, ...props }: BoxProps, ref) => (
  <CTable
    ref={ref}
    as={Box}
    variant="simple"
    sx={{
      display: 'table',
      tableLayout: 'fixed',
      ...sx,
    }}
    {...props}
  >
    {children}
  </CTable>
));
